<template>
  <div class="container">
    <el-dialog
      :title="updateReceiverParams.id? '编辑收货人':'添加收货人'"
      :visible.sync="update_receiver_dialog"
      width="600px"
      append-to-body
    >
      <el-form
        :model="updateReceiverParams"
        ref="updateReceiverParams"
        :rules="rules"
        label-width="120px"
        class="demo-ruleForm ipt_550px"
      >
        <el-form-item prop="company" label="公司名称">
          <el-input v-model="updateReceiverParams.company"></el-input>
        </el-form-item>
        <el-form-item prop="addr" label="公司地址">
          <el-input v-model="updateReceiverParams.addr"></el-input>
        </el-form-item>
        <el-form-item prop="country" label="国家">
          <el-select v-model="updateReceiverParams.country" filterable placeholder="请选择">
            <el-option
              v-for="(couItem,i) in countryData"
              :key="i"
              :label="couItem.name"
              :value="couItem.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="telephone" label="收货人固话">
          <el-input v-model="updateReceiverParams.telephone"></el-input>
        </el-form-item>
        <el-form-item prop="name" label="收货人姓名">
          <el-input v-model="updateReceiverParams.name"></el-input>
        </el-form-item>
        <el-form-item prop="phone" label="收货人手机">
          <el-input v-model="updateReceiverParams.phone"></el-input>
        </el-form-item>
        <el-form-item prop="email" label="收货人邮箱">
          <el-input v-model="updateReceiverParams.email"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="update_receiver_dialog = false">取 消</el-button>
        <el-button type="primary" @click="updateConfirm('updateReceiverParams')">确 定</el-button>
      </span>
    </el-dialog>
    <div class="popup">
      <div class="popup_header flex mb_20">
        <div class="mr_20">
          <!-- <el-button @click="showReceiverDialogAdd"
                     class="mr_80"
          type="primary">+添加收货人</el-button>-->
        </div>
        <div class="popup_search flex">
          <div class="w_220 mr_20">
            <el-input v-model="receiverParams.name" placeholder="姓名、国家、地址、公司名称" @keyup.enter.native="getReceiverDataSearch()"></el-input>
          </div>
          <el-button @click="getReceiverDataSearch()" type="primary">搜索</el-button>
          <el-button
            @click="resetLinkData"
            type="danger"
          >重置</el-button>
        </div>
      </div>
      <div class="popup_main">
        <el-table :data="receiverData" border style="width: 100%" class="mb_20">
          <el-table-column prop="company" label="公司" width="180"></el-table-column>
          <el-table-column prop="country" label="国家" width="180"></el-table-column>
          <el-table-column prop="addr" label="地址"></el-table-column>
          <el-table-column prop="email" label="邮箱"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="r">
              <el-button @click="receiverSelected(r.$index,r.row)" type="text">选择</el-button>
              <!-- <el-button @click="showReceiverDialog(r.$index,r.row)"
              type="text">编辑</el-button>-->
              <!-- <el-button @click="receiverDelete(r.$index,r.row)"
                         class="color_red"
              type="text">删除</el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="flex justify_end">
      <el-pagination
        @current-change="receiverPageChange"
        background
        layout="total, prev, pager, next"
        :page-size="receiverParams.pageSize"
        :current-page="receiverParams.pageNum"
        :total="receiverTotal"
      ></el-pagination>
    </div>
  </div>
  <!-- <el-dialog
        title="我的境外收货人"
        :visible.sync="receiver_dialog"
      >
      <el-form
        :model="updateReceiverParams"
        :rules="rules"
        ref="updateReceiverParams"
        label-width="40%"
        class="demo-ruleForm"
      >
        <el-dialog
          :title="updateReceiverParams.id? '编辑收货人':'添加收货人'"
          :visible.sync="update_receiver_dialog"
          width="30%"
          append-to-body
        >
          <el-form-item prop="company" label="公司名称">
            <el-input
              v-model="updateReceiverParams.company"
            ></el-input>
          </el-form-item>
          <el-form-item prop="addr" label="公司地址">
            <el-input
              v-model="updateReceiverParams.addr"
            ></el-input>
          </el-form-item>
          <el-form-item prop="country" label="国家">
            <el-select
              v-model="updateReceiverParams.country"
              placeholder="请选择"
            >
              <el-option
                v-for="(couItem,i) in countryData"
                :key="i"
                :label="couItem.ch"
                :value="couItem.ch">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="telephone" label="收货人固话">
            <el-input
              v-model="updateReceiverParams.telephone"
            ></el-input>
          </el-form-item>
          <el-form-item prop="name" label="收货人姓名">
            <el-input
              v-model="updateReceiverParams.name"
            ></el-input>
          </el-form-item>
          <el-form-item prop="phone" label="收货人手机">
            <el-input
              v-model="updateReceiverParams.phone"
            ></el-input>
          </el-form-item>
          <el-form-item prop="email" label="收货人邮箱">
            <el-input
              v-model="updateReceiverParams.email"
            ></el-input>
          </el-form-item>
          <span slot="footer" class="dialog-footer">
            <el-button @click="update_receiver_dialog = false">取 消</el-button>
            <el-button type="primary" @click="updateConfirm('updateReceiverParams')">确 定</el-button>
          </span>
        </el-dialog>
      </el-form>
        <div class="popup">
          <div class="popup_header flex mb_20">
            <el-button
              @click="showReceiverDialogAdd"
              class="mr_80"
              type="primary"
            >+添加收货人</el-button>
            <div class="popup_search flex">
              <div class="w_220 mr_20">
                <el-input v-model="receiverParams.name" placeholder="收货人地址、姓名、邮箱、国家"></el-input>
              </div>
              <el-button
                @click="getReceiverData()"
                type="primary"
              >搜索</el-button>
            </div>
          </div>
          <div class="popup_main">
            <el-table
              :data="receiverData"
              border
              style="width: 100%"
              class="mb_20"
            >
              <el-table-column
                prop="company"
                label="公司"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="country"
                label="国家"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="addr"
                label="地址"
              ></el-table-column>
              <el-table-column
                prop="email"
                label="邮箱"
              ></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="r">
                  <el-button @click="receiverSelect(r.$index,r.row)" type="text">选择</el-button>
                  <el-button
                    @click="showReceiverDialog(r.$index,r.row)"
                    type="text"
                  >编辑</el-button>
                  <el-button @click="receiverDelete(r.$index,r.row)" class="color_red" type="text">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="flex justify_end">
          <el-pagination
            @current-change="receiverPageChange"
            background
            layout="total, prev, pager, next"
            :page-size="receiverParams.pageSize"
            :current-page="receiverParams.pageNum"
            :total="receiverTotal">
          </el-pagination>
        </div>
        <div slot="footer" class="dialog_footer">
          <el-button @click="link_dialog = false">关 闭</el-button>
        </div>
  </el-dialog>-->
</template>

<script>
export default {
  props: {
    countryData: Array,
  },
  data() {
    return {
      update_receiver_dialog: false,
      updateReceiverParams: {},
      rules: {
        company: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        country: [
          { required: true, message: '请选择国家', trigger: 'change' }
        ],
      },
      receiverData: [],
      receiverParams: {
        cid: sessionStorage.customerId,
        pageNum: 1,
        pageSize: 10,
        name: '',
      },
      receiver_dialog: false,
      receiverTotal: 0,
    };
  },
  created() {
    this.getReceiverData();
  },
  methods: {
    receiverSelected(i, r) {
      this.$emit('receiverSelected', r);
    },
    updateConfirm(formName) {
      let updateReceiverParams = this.updateReceiverParams;
      // if (!updateReceiverParams.company) {
      //   this.$message.warning('请输入公司名称');
      //   return;
      // }
      // if (!updateReceiverParams.addr) {
      //   this.$message.warning('请输入公司地址');
      //   return;
      // }
      // if (!updateReceiverParams.country) {
      //   this.$message.warning('请选择国家');
      //   return;
      // }
      // if (!updateReceiverParams.telephone) {
      //   this.$message.warning('请输入收货人固定电话');
      //   return;
      // }
      // if (!updateReceiverParams.name) {
      //   this.$message.warning('请输入收货人姓名');
      //   return;
      // }
      // if (!updateReceiverParams.phone) {
      //   this.$message.warning('请输入收货人手机');
      //   return;
      // }
      // if (!updateReceiverParams.email) {
      //   this.$message.warning('请输入收货人邮箱');
      //   return;
      // }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.updateReceiverParams.id) {
            this.updateContacter();
            return;
          }
          this.addContacter();
        } else {
          this.$message.warning('请检查信息是否输入完整');
        }
      });

    },
    // 编辑收货人
    updateContacter() {
      this.$axios
        .post('/user/cusReceivers/update', this.updateReceiverParams)
        .then(res => {
          if (res.data.result) {
            this.$message.success('编辑成功');
            this.getReceiverData();
            this.update_receiver_dialog = false;
          }
        });
    },
    // 新增收货人
    addContacter() {
      this.$axios
        .post('/user/cusReceivers/add', this.updateReceiverParams)
        .then(res => {
          if (res.data.result) {
            this.$message.success('添加成功');
            this.getReceiverData();
            this.update_receiver_dialog = false;
          }
        });
    },
    // 删除收货人
    receiverDelete(i, r) {
      this.$confirm('是否删除该收货人?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios
          .get('/user/cusReceivers/delete', {
            params: { id: r.id },
          })
          .then(res => {
            if (res.data.result) {
              this.$message.success('删除成功');
              this.getReceiverData();
            }
          });
      }).catch(() => { });
    },
    showReceiverDialog(i, r) {
      this.updateReceiverParams = r;
      this.update_receiver_dialog = true;
    },
    showReceiverDialogAdd() {
      this.updateReceiverParams = {
        cid: sessionStorage.userId,
      };
      this.update_receiver_dialog = true;
      this.$nextTick(() => {
        this.$refs['updateReceiverParams'].clearValidate();
      })
    },
    receiverPageChange(i) {
      this.receiverParams.pageNum = i;
      this.getReceiverData();
    },
    getReceiverDataSearch(){
      this.receiverParams.pageNum = 1;
      this.getReceiverData();
    },
    // 重置
    resetLinkData(){
      this.receiverParams = {
        cid: sessionStorage.customerId,
        pageNum: 1,
        pageSize: 10,
        name: '',
      };
      this.getReceiverData()
    },
    getReceiverData() {
      console.log(this.receiverParams)
      this.$axios
        .get("/user/placeOrder/getCusReceivers", {
          params: this.receiverParams,
        })
        .then(res => {
          if (res.status == 200) {
            this.receiverData = res.data.list.list;
            this.receiverTotal = res.data.list.total;
          }
        });
    },
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/theReceiver.vue